import {
	type DataTableAction,
	type PermissionRule,
	useAuth,
} from "@k3-tech/react-kit";
import { useMemo } from "react";

export type DataTableActionWithPermission = DataTableAction & {
	permissions?: PermissionRule["permissions"];
	requireAll?: boolean;
	bypassPermission?: boolean;
};

export function useGuardedDataTableActions(
	actions: DataTableActionWithPermission[],
) {
	const { can } = useAuth();

	const renderedDataTableActions = useMemo(() => {
		return actions
			.filter((action) => {
				const pass =
					action.permissions != null
						? can({
								permissions: action.permissions,
								requireAll: action.requireAll,
							})
						: false;
				return pass || action.bypassPermission;
			})
			.map(
				({
					permissions: _p,
					bypassPermission: _b,
					requireAll: _r,
					...action
				}) => action satisfies DataTableAction,
			);
	}, [actions, can]);

	return renderedDataTableActions;
}
